import * as React from "react";
import { Checkbox as CheckboxWidget, FormLabel, Grid } from "./widget";
import { WithStyles, withStyles, createStyles } from "./styles";
import { bind, Control, ControlProps } from "./Control";

const styles = () => createStyles({
    root: {
        fontSize: '0.85rem',
        color: 'rgba(0,0,0,0.87)',
        fontWeight: 'normal',
    }
});



const Checkbox = withStyles(styles)((props: ControlProps & WithStyles<typeof styles>) => {
    const id = props.name;
    const binding = bind(props);

    const { hideLabel, classes, ...other } = props;

    const hideControlLabel = hideLabel !== false;
    const showLabel = hideLabel !== true;

    return <Control {...other} hideLabel={hideControlLabel}>
        {showLabel ?
            <Grid container direction="row" alignItems="center">
                <Grid item>
                    <CheckboxWidget
                        autoFocus={props.autoFocus}
                        name={props.name}
                        id={id}
                        placeholder={props.placeholder}
                        checked={binding.value === true}
                        onChange={e => binding.onChange(e.currentTarget.checked)} />
                </Grid>
                <Grid item>
                    <FormLabel className={classes.root} htmlFor={id}>{hideControlLabel ? props.label : props.children}</FormLabel>
                </Grid>
            </Grid> : <CheckboxWidget
                autoFocus={props.autoFocus}
                name={props.name}
                id={id}
                placeholder={props.placeholder}
                checked={binding.value === true}
                onChange={e => binding.onChange(e.currentTarget.checked)} />}
    </Control>;
});

export {
    Checkbox
};
